/**
 * @generated SignedSource<<8564fe2ccdb51886e7be41b51e8e60d0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type topBar_issueNavigator_viewResult$data = {
  readonly " $fragmentSpreads": FragmentRefs<"hierarchyToggle_issueNavigator_HierarchyToggleItem">;
  readonly " $fragmentType": "topBar_issueNavigator_viewResult";
};
export type topBar_issueNavigator_viewResult$key = {
  readonly " $data"?: topBar_issueNavigator_viewResult$data;
  readonly " $fragmentSpreads": FragmentRefs<"topBar_issueNavigator_viewResult">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "topBar_issueNavigator_viewResult",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "hierarchyToggle_issueNavigator_HierarchyToggleItem"
    }
  ],
  "type": "JiraIssueSearchView"
};

(node as any).hash = "92131635561c1513fd7bd3e44159086b";

export default node;
